import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
export const LayoutBreadcrumbs = ({ breadcrumbs }) => {
    const lastIndex = useMemo(() => breadcrumbs && breadcrumbs.length - 1, [breadcrumbs]);
    const renderBreadcrumbs = useMemo(() => breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map((b, i) => (_jsx(Breadcrumb.Item, Object.assign({ href: b.href, active: i === lastIndex }, { children: b.title }), b.href))), [breadcrumbs]);
    if (!breadcrumbs)
        return null;
    return _jsx(Breadcrumb, { children: renderBreadcrumbs });
};
